// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3FumS","signatureBlock":"Footer_signatureBlock__cr2Vt","signature":"Footer_signature__3Ulxu"};